"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newsletterComponent = exports.NewsletterComponent = void 0;
const app_1 = require("app");
const Forms_1 = require("Forms");
const SignUpUtils_1 = require("Views/Partials/Components/SignUp/services/SignUpUtils");
const NewsletterFormConfig_1 = require("./NewsletterFormConfig");
const formLoad_1 = require("./formLoad");
class NewsletterComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.newsletter-signup';
        this.formWrapId = '#newsletter-form';
        this.renderLoader = (popupAriaLabel, closeButtonAriaLabel) => {
            (0, formLoad_1.renderLoader)(formLoad_1.renderComponent.Spinner, this.wrapper, null, 'newsletter-form group', popupAriaLabel, closeButtonAriaLabel);
        };
        this.renderMessage = (title, message, buttonLabel) => {
            (0, formLoad_1.renderLoader)(formLoad_1.renderComponent.Message(message, buttonLabel), this.wrapper, title, 'newsletter-form newsletter-form--message group');
        };
        this.getBusinessFields = (formType) => {
            const commonBusinessFields = {
                company: 'company',
                department: 'department',
                jobFunction: 'function',
            };
            const newsletterSpecificBusinessFields = {
                companyType: 'companyType',
            };
            const isNewsletterForm = formType === NewsletterFormConfig_1.formTypes.newsletter;
            return Object.assign(Object.assign({}, commonBusinessFields), (isNewsletterForm && newsletterSpecificBusinessFields));
        };
        this.getFormFields = (formType) => {
            const generalFields = {
                country: 'country',
                email: 'email',
                firstName: 'firstName',
                language: 'language',
                lastName: 'lastName',
            };
            return Object.assign(Object.assign({}, generalFields), this.getBusinessFields(formType));
        };
    }
    OnInit() {
        this.wrapper = $(this.formWrapId).get(0);
        this.el.forEach(el => {
            this.InitForm(el);
        });
    }
    convertData(formType, model, countries, languages) {
        return {
            consentText: model.specificFields.userConsentText,
            consentValidationMessage: model.specificFields.userConsentValidationMessage,
            chineseConsentText: model.specificFields.userChineseConsentText,
            chineseConsentValidationMessage: model.specificFields.userChineseConsentValidationMessage,
            countries,
            numberOfEmployees: [],
            departments: (0, Forms_1.formatOptions)(model.departments, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
            explanationText: model.specificFields.explanationText,
            functions: (0, Forms_1.formatOptions)(model.functions, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
            genericFields: model.genericFields,
            inputs: SignUpUtils_1.signUpUtils.formatInputs(this.getFormFields(formType), model.genericFields, model.specificFields),
            languages: SignUpUtils_1.signUpUtils.formatLanguages(languages),
            specificFields: model.specificFields,
            submitLabel: model.genericFields.submitLabel,
            userTypes: model.userTypes,
            companyTypes: model.companyTypes && (0, Forms_1.formatOptions)(model.companyTypes, SignUpUtils_1.propNames.key, SignUpUtils_1.propNames.value),
        };
    }
    InitForm(el) {
        const formType = app_1.AttrService.data(el, 'form-type');
        const apiUrl = app_1.AttrService.data(el, 'url');
        const pageId = app_1.AttrService.data(el, 'page');
        const control = app_1.AttrService.data(el, 'control');
        const locationApiUrl = app_1.AttrService.data(el, 'location-api-base-url');
        const locationApiKey = app_1.AttrService.data(el, 'location-api-key');
        const culture = app_1.AttrService.data(el, 'culture');
        const defaultErrorMsg = app_1.AttrService.data(el, 'error-message');
        const popupAriaLabel = app_1.AttrService.data(el, 'newsletter-aria-label');
        const closeButtonAriaLabel = app_1.AttrService.data(el, 'close-button-aria-label');
        const bypassRecaptchaKey = app_1.AttrService.data(el, 'bypass-recaptcha-key');
        const additionalFormData = {
            applications: app_1.AttrService.data(el, 'applications'),
            markets: app_1.AttrService.data(el, 'markets'),
            segments: app_1.AttrService.data(el, 'segments'),
            solutions: app_1.AttrService.data(el, 'solutions'),
            subSegments: app_1.AttrService.data(el, 'subSegments'),
        };
        const countryService = SignUpUtils_1.signUpUtils.createCountryService(locationApiUrl, culture, locationApiKey);
        el.querySelector('.cta').addEventListener('click', ev => {
            ev.preventDefault();
            // open modal && show preloader
            this.renderLoader(popupAriaLabel, closeButtonAriaLabel);
            const formDataPromise = SignUpUtils_1.signUpUtils.getFormData(apiUrl, { pageId });
            const countryPromise = countryService.getDataForSelectOptions();
            const buttonLabel = $(ev.target).text().trim();
            const labelsAndPageId = {
                buttonLabel,
                pageId,
                popupAriaLabel,
                closeButtonAriaLabel,
            };
            Promise.all([formDataPromise, countryPromise])
                .then(([formData, countries]) => {
                const languages = SignUpUtils_1.signUpUtils.convertLanguages(formData.languages);
                const formItems = this.convertData(formType, formData, countries, languages);
                const reCaptchaSiteKey = formData.reCaptchaSiteKey;
                this.renderForm(formType, formData, formItems, additionalFormData, reCaptchaSiteKey, control, labelsAndPageId, bypassRecaptchaKey);
            })
                .catch(err => {
                this.renderMessage(null, err.response.data.message || defaultErrorMsg);
            });
        });
    }
    renderForm(formType, formData, formItems, additionalFormData, reCaptchaSiteKey, control, labelsAndPageId, bypassRecaptchaKey) {
        const title = formData.specificFields && formData.specificFields.titleText
            ? formData.specificFields.titleText
            : null;
        const inputObject = this.getInputObject(formItems);
        const gtmData = {
            label: labelsAndPageId.buttonLabel,
            title,
            control,
        };
        app_1.GTM.newsletter.open(gtmData);
        const onModelClose = () => {
            app_1.GTM.newsletter.abandon(gtmData);
        };
        if (formData.culture) {
            additionalFormData.culture = formData.culture;
        }
        const renderSpinner = () => {
            this.renderLoader(labelsAndPageId.popupAriaLabel, labelsAndPageId.closeButtonAriaLabel);
        };
        const signUpTypes = {
            formType,
            formItems,
            inputObject,
        };
        const hashMapTypes = {
            additionalFormData,
            businessFields: this.getBusinessFields(formType),
            formFields: this.getFormFields(formType),
        };
        const render = {
            renderSpinner,
            renderMessage: this.renderMessage,
        };
        // render form instead loader
        (0, formLoad_1.renderLoader)(formLoad_1.renderComponent.Form(signUpTypes, formData.postUrl, hashMapTypes, reCaptchaSiteKey, bypassRecaptchaKey, render, control, labelsAndPageId.pageId), this.wrapper, title, 'newsletter-form group', labelsAndPageId.popupAriaLabel, labelsAndPageId.closeButtonAriaLabel, onModelClose);
    }
    getInputObject(formItems) {
        const { inputs, countries, functions, departments, companyTypes, genericFields, specificFields, languages, userTypes, } = formItems;
        const inputObject = inputs.reduce((acc, currentValue) => {
            acc[currentValue.name] = currentValue;
            return acc;
        }, {});
        inputObject.country.options = countries;
        inputObject.jobFunction.options = functions;
        inputObject.department.options = departments;
        inputObject.companyType && (inputObject.companyType.options = companyTypes);
        inputObject.language.languages = languages;
        inputObject.userTypes = userTypes;
        inputObject.genericFields = genericFields;
        inputObject.specificFields = specificFields;
        return inputObject;
    }
}
exports.NewsletterComponent = NewsletterComponent;
exports.newsletterComponent = new NewsletterComponent();
